import { render, staticRenderFns } from "./PublishStatusListLabel.vue?vue&type=template&id=b615497c&scoped=true&"
import script from "./PublishStatusListLabel.vue?vue&type=script&lang=js&"
export * from "./PublishStatusListLabel.vue?vue&type=script&lang=js&"
import style0 from "./PublishStatusListLabel.vue?vue&type=style&index=0&id=b615497c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b615497c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/www/uat.mediaworkflow.winnipeg.ca/laravel/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b615497c')) {
      api.createRecord('b615497c', component.options)
    } else {
      api.reload('b615497c', component.options)
    }
    module.hot.accept("./PublishStatusListLabel.vue?vue&type=template&id=b615497c&scoped=true&", function () {
      api.rerender('b615497c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/csmworkflow/js/components/deliverables/PublishStatusListLabel.vue"
export default component.exports